import React from "react";
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';

import FindOrder from "./FindOrder";
import CheckProgress from "./CheckProgress";

function TrackOrder() {

    return(
        <>

        <div className="container">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <Nav className="cartNav large">
                    <Nav.Item>
                    <Nav.Link eventKey="first">find order</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                    <Nav.Link eventKey="second">check progress</Nav.Link>
                    </Nav.Item>
                </Nav>
                <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <FindOrder/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                       <CheckProgress/>
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </div>

        </>
    )
}

export default TrackOrder;